<template>

    <div>
        <div class="h1 my-2">産品管理</div>
        <span class="mb-2 d-flex">
            <product-editor :categories="categories" @product:created="productCreated">Create Product</product-editor>
        </span>
        <product-list :categories="categories" ref="products"></product-list>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                products: [],
                categories: []
            }
        },
        mounted() {
            this.categories = this.fetchCategories();
        },
        methods: {
            productCreated(new_product) {
                this.$refs.products.addProduct(new_product);
            },
            fetchCategories() {
                axios.get(base_url + '/admin/api/categories')
                    .then(({ data }) => {
                        try {
                            this.categories = data;
                        } catch (e) { console.error(e) }
                    })
                    .catch((...error) => console.log(error));
            }
        }
    }
</script>